import axios from 'axios';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var VersioningStrategy;

(function (VersioningStrategy) {
  VersioningStrategy["QueryString"] = "QUERY_STRING";
  VersioningStrategy["UrlPath"] = "URL_PATH";
  VersioningStrategy["MediaType"] = "MEDIA_TYPE";
})(VersioningStrategy || (VersioningStrategy = {}));

function replaceUrlPathWithVersion(url, apiVersion) {
  // the template name of the api version must be "apiVersion"
  return url.replace('{apiVersion}', apiVersion);
}

function enhanceConfigByVersioningStrategy(requestConfig, versioningConfig) {
  // we prioritize the apiVersion passed via the RequestConfig first
  // then use the initial versioningConfig last
  var apiVersion = requestConfig['apiVersion'] || versioningConfig['apiVersion']; // same way here, we prioritize the RequestConfig first then the initial defaults

  var versioningStrategy = requestConfig['versioningStrategy'] || versioningConfig['versioningStrategy'];

  if (versioningStrategy === VersioningStrategy.QueryString) {
    var _extends2;

    requestConfig.params = _extends({}, requestConfig.params, (_extends2 = {}, _extends2[versioningConfig.queryStringKeyName] = apiVersion, _extends2));
  }

  if (versioningStrategy === VersioningStrategy.MediaType) {
    var defaultAcceptHeader = requestConfig.headers.common['Accept'];
    var reqAcceptHeader = requestConfig.headers['Accept'] || undefined; // we prioritize an accept header passed in the RequestConfig but default to the
    // the common default accept header value axios provides

    var acceptHeader = reqAcceptHeader || defaultAcceptHeader;

    if (versioningConfig.mediaTypeFormatter) {
      var _extends3;

      var formattedAcceptHeader = versioningConfig.mediaTypeFormatter({
        apiVersion: apiVersion,
        acceptHeader: acceptHeader,
        mediaTypeKeyName: versioningConfig.mediaTypeKeyName
      });
      requestConfig.headers = _extends({}, requestConfig.headers, (_extends3 = {}, _extends3['Accept'] = formattedAcceptHeader, _extends3));
    } else {
      var _extends4;

      requestConfig.headers = _extends({}, requestConfig.headers, (_extends4 = {}, _extends4['Accept'] = acceptHeader + (";" + versioningConfig.mediaTypeKeyName + "=" + apiVersion), _extends4));
    }
  }

  if (versioningStrategy === VersioningStrategy.UrlPath) {
    var url = requestConfig.url,
        baseURL = requestConfig.baseURL;

    if (url) {
      requestConfig.url = replaceUrlPathWithVersion(url, apiVersion);
    }

    if (baseURL) {
      requestConfig.baseURL = replaceUrlPathWithVersion(baseURL, apiVersion);
    }
  }

  return requestConfig;
}

function injectApiVersioningInterceptor(instance, versioningConfig) {
  // add an interceptor
  instance.interceptors.request.use(function (requestConfig) {
    var enhancedConfig = enhanceConfigByVersioningStrategy(requestConfig, versioningConfig);
    return enhancedConfig;
  });
}

var defaultWithVersioningConfig = {
  mediaTypeKeyName: 'v',
  queryStringKeyName: 'api-version'
};

function withVersioning(instance, config) {
  // merge default config options
  var versioningConfig = _extends({}, defaultWithVersioningConfig, {}, config); // clone the instance so we don't affect it in any way


  var clonedInstance = axios.create(instance.defaults); // add required api versioning interceptor

  injectApiVersioningInterceptor(clonedInstance, versioningConfig);
  return clonedInstance;
}

export { VersioningStrategy, withVersioning };